const {
  REPORT_STATUSES,
  CIVIL_STATUSES,
  PROVINCES,
  APPROXIMATE_ADULT_INCOMES,
  APPROXIMATE_CHILD_INCOMES,
  PERSON_TYPES,
  GENDERS,
  DOCUMENT_TO_APPROVE_URL_PARAM,
  INVESTMENT_PLATFORM_INTEREST_LEVELS,
  PREFERRED_CONTACT_METHODS,
  QUESTION_CATEGORIES,
  QUESTION_CATEGORIES_SPECIFIC_TO_PROVINCE,
  INCOME_SOURCES,
  TAX_CREDITS,
} = require('acces-impot-utils/lib/report')
const { DOCUMENT_TYPES } = require('./constants/document')
const documentHelpers = require('./helpers/document')

module.exports = {
  ...documentHelpers,

  PAYMENT_METHOD_URL_PARAM: 'paymentMethod',
  DOCUMENT_TO_APPROVE_URL_PARAM,
  SUCCESSFUL_PAYMENT_URL_PARAM: 'orderSuccess',
  SUCCESSFUL_SIGNATURE_URL_PARAM: 'signed',
  SUCCESSFUL_SIGNATURE_URL_PARAM_SEPARATOR: '_',

  personTypes: PERSON_TYPES,
  PERSON_TYPES,

  genders: GENDERS,
  GENDERS,

  civilStatuses: CIVIL_STATUSES,
  provinces: {
    ca: PROVINCES,
  },
  nonCanadianSituations: {
    permanentResident: 'permanentResident',
    temporaryResident: 'temporaryResident',
    temporaryWorker: 'temporaryWorker',
    foreignStudent: 'foreignStudent',
    nonResident: 'nonResident',
  },
  APPROXIMATE_ADULT_INCOMES,
  APPROXIMATE_CHILD_INCOMES,
  QUESTION_CATEGORIES,
  QUESTION_CATEGORIES_SPECIFIC_TO_PROVINCE,
  questionCategories: QUESTION_CATEGORIES,
  documentTypes: DOCUMENT_TYPES,
  drugInsuranceCoverages: {
    groupInsurance: 'groupInsurance',
    insuranceFromFamily: 'insuranceFromFamily',
    publicInsurance: 'publicInsurance',
    notEntitledToDrugInsurance: 'notEntitledToDrugInsurance',
  },
  deprecatedDrugInsuranceParticularSituations: {
    minorUnmarried: 'minorUnmarried',
    fullStudent1825: 'fullStudent1825',
    jamesBayAgreement: 'jamesBayAgreement',
    freeMed65: 'freeMed65',
    bookFree65: 'bookFree65',
    validBooklet: 'validBooklet',
    chsld: 'chsld',
    impairmentB18yo: 'impairmentB18yo',
    foreignNational: 'foreignNational',
    resOutsideBusinessQc: 'resOutsideBusinessQc',
  },
  drugInsuranceParticularSituations: {
    no: 'no',
    privateInsuranceComplementaryRamq65: 'privateInsuranceComplementaryRamq65',
    socialAssistance: 'socialAssistance',
    indianOrInuit: 'indianOrInuit',
    stayedOutsideQc: 'stayedOutsideQc',
    frenchStudent: 'frenchStudent',
  },
  solidarityTaxCreditWhoAsk: {
    yourself: 'yourself',
    partner: 'partner',
  },
  solidarityTaxCreditOwnOrRent: {
    own: 'own',
    rent: 'rent',
    none: 'none',
  },
  trilliumBenefitWhoAsk: {
    yourself: 'yourself',
    partner: 'partner',
  },
  trilliumBenefitOwnOrRent: {
    owner: 'owner',
    tenant: 'tenant',
    studentResidence: 'studentResidence',
    publicLongTermCare: 'publicLongTermCare',
    none: 'none',
  },
  INCOME_SOURCES,
  incomeSources: INCOME_SOURCES,
  TAX_CREDITS,
  taxCredits: TAX_CREDITS,
  withdrawUnderHbpLlp: {
    no: 'no',
    underHbp: 'underHbp',
    underLlp: 'underLlp',
    underHbpAndLlp: 'underHbpAndLlp',
  },
  investmentPlatformInterestLevel: INVESTMENT_PLATFORM_INTEREST_LEVELS,
  preferredContactMethod: PREFERRED_CONTACT_METHODS,
  documentFileOptions: {
    additional: 'additional',
  },
  frequencies: {
    weekly: 'weekly',
    monthly: 'monthly',
    annually: 'annually',
  },
  fileStatuses: REPORT_STATUSES,
  REPORT_STATUSES,
}
